const ConfigSecciones={
    "contacto":{
        "redes_sociales":{
            "activado":"false"
        }
    },
    "producto_ver":{
        "especificaciones_personalizadas":"false",
        "especificaciones_contenido":{
            "activada":"false"
        }
    }
}

export default ConfigSecciones;
